// @owners { team: patients }
import { getCompanyName } from '~shared/config/getCompanyName';

// The name Stripe renders in its card forms: the consent copy on the web Payment
// Element ("you allow X to charge your card...") and the native PaymentSheet's
// merchant name. Without an override, Stripe falls back to the account-level
// business name, which shows "Alto Pharmacy" on Fuze Health and FuzeRx.
export const getStripeBusinessName = (): string => {
  const companyName = getCompanyName();

  if (companyName === 'Fuze Health') {
    return 'Fuze Health';
  }

  if (companyName === 'FuzeRx') {
    return 'FuzeRx';
  }

  return 'Alto Pharmacy';
};
